// Ask the browser to make IndexedDB DURABLE (not evictable). Without this, a
// device under storage pressure can evict the outbox and lose un-synced sales
// (spec §8.1/§8.9). Best-effort: returns whether storage is persisted.

export async function requestPersistentStorage(): Promise<boolean> {
  if (typeof navigator === "undefined" || !navigator.storage?.persist) {
    return false;
  }
  try {
    if (await navigator.storage.persisted?.()) {
      return true;
    }
    return await navigator.storage.persist();
  } catch {
    return false;
  }
}

export async function isStoragePersisted(): Promise<boolean> {
  if (typeof navigator === "undefined" || !navigator.storage?.persisted) {
    return false;
  }
  try {
    return await navigator.storage.persisted();
  } catch {
    return false;
  }
}

/** Remaining storage headroom (bytes), or null if the API is unavailable. */
export async function storageHeadroomBytes(): Promise<number | null> {
  if (typeof navigator === "undefined" || !navigator.storage?.estimate) {
    return null;
  }
  try {
    const { quota, usage } = await navigator.storage.estimate();
    if (typeof quota === "number" && typeof usage === "number") {
      return Math.max(0, quota - usage);
    }
    return null;
  } catch {
    return null;
  }
}
